import React, { useEffect } from "react";
import { getIPAddress } from "../models/locationHelpers";
import { sendSlackMessage } from "../models/notifications";
import NavBarComponent from "../components/navBar/NavBarComponent";
import FooterComponent from "../components/home/FooterComponent";
import APIPageHomeComponent from "../components/apiComponents/APIPageHomeComponent";

export default function StoreCreditApi() {
    useEffect(() => {
        getIPAddress((ipAddress) => {
            sendSlackMessage(`🧑‍💻$$ Visitor is visiting the API page ${ipAddress}`, "#website-updates");
        });
    }, []);

    return (
        <div>
            <NavBarComponent />
            <APIPageHomeComponent />
            <FooterComponent />
        </div>
    );
}
